import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["title", "message", "instructions", "trace", "variant", "_style", "_hr_style", "dismiss_variant", "onDismiss"];
import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function ErrorAlert(_ref) {
  var title = _ref.title,
    message = _ref.message,
    instructions = _ref.instructions,
    trace = _ref.trace,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'danger' : _ref$variant,
    _style = _ref._style,
    _hr_style = _ref._hr_style,
    _ref$dismiss_variant = _ref.dismiss_variant,
    dismiss_variant = _ref$dismiss_variant === void 0 ? variant : _ref$dismiss_variant,
    _ref$onDismiss = _ref.onDismiss,
    onDismiss = _ref$onDismiss === void 0 ? function () {} : _ref$onDismiss,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState('show' in props ? props.show : true),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  if (!show) {
    return null;
  }
  console.debug('error', {
    message: message
  }, typeof message);
  return /*#__PURE__*/_jsxs(Alert, {
    show: show,
    variant: variant,
    style: _style,
    children: [/*#__PURE__*/_jsx(Alert.Heading, {
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      children: [instructions, trace ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsx("pre", {
          children: JSON.stringify(trace)
        })]
      }) : null]
    }), /*#__PURE__*/_jsx("hr", {
      style: _hr_style
    }), /*#__PURE__*/_jsx("div", {
      className: "d-flex justify-content-end",
      children: /*#__PURE__*/_jsx(Button, {
        onClick: function onClick() {
          setShow(false);
          onDismiss();
        },
        variant: "outline-".concat(dismiss_variant),
        children: "Dismiss"
      })
    })]
  });
}
export { ErrorAlert };